
<template>
  <div class="vip-detail">
    <slot name="vipDetail">了解优学VIP课程包</slot>
  </div>
</template>

<script>
export default {

}
</script>
<style scoped>
.vip-detail {
  background: #FFC44C;
  color: #ffffff;
}
.blue{
  background: #74B3FA;
  color: #ffffff;
}
</style>